import './Publications.css'
import Actions from '../actions/Actions'
import { useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import logos from "../img/logo192.png"

function Publications() {
    return (
        <div className="team-main">
            <Container className='publications-container'>
                <h1 className='publication-title'>Scientific <b className='blue'>Publications</b></h1>


                {/* Papers In Conferences*/}
                <h3 className='publication-subtitle'>Papers In Conferences</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Damage Detection in Concrete Dams Using Dynamic Continuous Monitoring</h3>
                            <p className='pub-afil'>Oliveira, S.; Rodrigues, J.; Mendes, P.; Campos Costa, A. (2002)</p>
                            <p className='pub-afil'>International Conference EPMESC2003, Macau, China</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1OX4HJAwixTk9FHFwfQjJtEcir2QDZYlT/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Monitoring the dynamic behaviour of concrete dams</h3>
                            <p className='pub-afil'>Oliveira, S.; Rodrigues, J.; Mendes, P.; Campos Costa, A. (2003)</p>
                            <p className='pub-afil'>VII Congresso de Mecânica Aplicada e Computacional, Évora, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1SCc7QMGOrVgRgm0BcWApdx-fgoTvMBqN/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Dynamic behaviour of concrete dams: monitoring and modelling</h3>
                            <p className='pub-afil'>Mendes, P.; Oliveira, S.; Guerreiro, S.; Baptista, M. A.; Campos Costa, A. (2004)</p>
                            <p className='pub-afil'>13th World Conference on Earthquake Engineering (WCEE), Vancouver, Canada</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/19p5x6IiPAHz8KGGoEMcmGRF478OwnPte/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Development of Cabril Dam Finite Element Models for Dynamic Analysis Using Ambient Vibration Test Results</h3>
                            <p className='pub-afil'>Oliveira, S.; Mendes, P. (2006)</p>
                            <p className='pub-afil'>III European Conference on Computational Mechanics. Solids, Structures and Coupled Problems in Engineering. LNEC, Lisbon, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1ApkNxXkidBwJrdtSLjBttQbZ9otijzXV/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Study of dam-reservoir dynamic interaction using vibration tests on a physical model</h3>
                            <p className='pub-afil'>Mendes, P.; Oliveira, S. (2007)</p>
                            <p className='pub-afil'>2nd International Operational Modal Analysis Conference, Copenhagen, Denmark</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1tXXdGGSOsJ_dGPaGG2yUSjBtGv15Iu6R/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Influence of the dynamic behaviour of the intake tower on modal identification of Cabril dam</h3>
                            <p className='pub-afil'>Mendes, P.; Oliveira, S. (2009)</p>
                            <p className='pub-afil'>3rd International Operational Modal Analysis Conference (IOMAC’09), Ancona, Italy</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1wXaIClFK_kpuisoaixPpLsY3_QhNpMjc/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Observation and analysis of the dynamic behavior of the Cabril dam water intake tower</h3>
                            <p className='pub-afil'>Espada, M.; Mendes, P.; Oliveira, S. (2010)</p>
                            <p className='pub-afil'>8º Congresso Nacional de Mecânica Experimental, Guimarães, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1t0XlQ5SLReeGgZtNxW3_X07R30TANF8t/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Monitoring the structural integrity of large concrete dams: the case of Cabril dam, Portugal</h3>
                            <p className='pub-afil'>Oliveira, S.; Ferreira, I.; Berberan, A.; Mendes, P.; Boavida, J.; Baptista, B. (2010)</p>
                            <p className='pub-afil'>HYDRO 2010, Lisbon, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1WWrNoO7dMdKe6Bmdr3C8MYL4d_a63Cpd/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Long-term dynamic monitoring systems for the safety control of large concrete dams. The case of Cabril dam, Portugal</h3>
                            <p className='pub-afil'>Oliveira, S.; Mendes, P.; Garrett, A.; Oliveira Costa, C.; Reis, J. (2011)</p>
                            <p className='pub-afil'>6th International Conference on Dam Engineering, Lisbon, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/10QR10Y1TvZa852TY87zDGirlI-Ox1H1s/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Dynamic monitoring of Cabril dam under ambient vibration. Influence of the intake tower dynamic behaviour</h3>
                            <p className='pub-afil'>Espada, M.; Mendes, P.; Oliveira, S. (2011)</p>
                            <p className='pub-afil'>6th International Conference on Dam Engineering. LNEC, Lisbon, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1u8rtRVGV_5jjah16oNUiJuBV-ZRNUCbl/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Long-term dynamic monitoring of arch dams. The case of Cabril dam, Portugal</h3>
                            <p className='pub-afil'>Oliveira, S.; Espada, M.; Câmara, R. (2012)</p>
                            <p className='pub-afil'>15th World Conference on Earthquake Engineering (WCEE), Lisbon, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1_6FIk7anRetFta69ukGV6NWCyjJxOTgE/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modeling the dynamic behavior of dam-reservoir-foundation systems considering generalized damping. Development of a 3DFEM state formulation</h3>
                            <p className='pub-afil'>Oliveira, S.; Silvestre, A.; Espada, M.; Câmara, R. (2014)</p>
                            <p className='pub-afil'>International Conference on Structural Dynamics (EURODYN), Porto, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1NmgBrvVA15bs_eGtTq2k-7YGGsAMr-Fu/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic safety evaluation of Luzzone dam. Use of a 3DFEM state formulation in pressures and displacements</h3>
                            <p className='pub-afil'>Oliveira, S., Alegre, A., Silvestre, A., Espada, M. Câmara, R. (2015)</p>
                            <p className='pub-afil'>13th ICOLD Int. Benchmark Workshop on Numerical Analysis of Dams. EPFL, Lausanne</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1db1NOWOUdCGJGCBJJKVSGGnzU8Fjk1EQ/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Vibrations in large dams. Monitoring and modelling</h3>
                            <p className='pub-afil'>Oliveira S., Alegre A. (2018)</p>
                            <p className='pub-afil'>ICOLD 26th Cong. and 86th Annu. Meeting, Vienna, Austria</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1bE90pYBSo1-W73K7b_IZPpnRBzKwkJBH/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic response of arch dams. Numerical study on the influence of reservoir water level</h3>
                            <p className='pub-afil'>Alegre, A.; Ramos, R.; Oliveira, S.; Espada, M. (2018)</p>
                            <p className='pub-afil'>3rd International Dam World Conference (DW18), Brazil, Foz do Iguaçu</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1b2O1FpWG_haK0WOn2BZovMXRksg_bW2G/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>SSHM systems for seismic monitoring and structural integrity control of concrete dams. LNEC's experience over the last decade</h3>
                            <p className='pub-afil'>Oliveira, S.; Alegre, A. (2019)</p>
                            <p className='pub-afil'>11º Congresso Nacional de Sismologia e Engenharia Sísmica (Sísmica2019). IST, Lisboa</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1L_ux4UlblK9o2SYAlIG-Z_prTYhXg_lX/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic and Structural Health Monitoring of Cabril Dam</h3>
                            <p className='pub-afil'>Oliveira, S.; Alegre, A. (2019)</p>
                            <p className='pub-afil'>3rd Meeting of EWG Dams and Earthquakes. An international Symposium, LNEC, Lisboa</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1PxvPq4BeJZfyrOWPnYyhdF4txjReH-UE/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic and structural health monitoring systems for large concrete dams</h3>
                            <p className='pub-afil'>Oliveira, S.; Alegre, A. (2019)</p>
                            <p className='pub-afil'>The 12th Int. Workshop on Structural Health Monitoring (IWSHM2019), Stanford University, Stanford, California, USA</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1XyeTX8ylc1uICxhl_05lAHUADtvL6HOJ/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Monitoring vibrations in large dams</h3>
                            <p className='pub-afil'>Alegre, A.; Carvalho, E.; Matsinhe, B.; Mendes, P.; Oliveira, S.; Proença, J. (2019)</p>
                            <p className='pub-afil'>HYDRO2019. Concept to Closure: Practical Steps, Porto, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1G1Q8OwBxM4Wgku1NqzmKP_ENHw7haLnv/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic and Structural Health Monitoring of Cahora Bassa dam and Non-Linear Seismic AnalysiS</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Carvalho, E., Matsinhe, B., Mendes, P., & Proença, J. (2020)</p>
                            <p className='pub-afil'>HYDRO 2020 - Strategies for Future Progress, Online event</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1AFj6ULMYH983OAcPYsecV-5R62wMYVm2/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Use of SSHM data for dynamic behaviour analysis and damage detection on large dams. The cases of Cabril dam and Cahora Bassa dam</h3>
                            <p className='pub-afil'>Alegre, A., Mendes, P., Carvalho, E., Matsinhe, B., Oliveira, S., & Proença, J. (2021)</p>
                            <p className='pub-afil'>10th International Conference on Structural Health Monitoring of Intelligent Infrastructure (SHMII-10), Porto, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1BWHv8z_MiYqQffjse5BgRhAjI3JmcXgv/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Measured response of a large arch dam. Comparison with FE results from DamDySSA and Code_Aster</h3>
                            <p className='pub-afil'>Alegre, A.; Robbe, E.; Oliveira, S.  (2021)</p>
                            <p className='pub-afil'>10th International Conference on Structural Health Monitoring of Intelligent Infrastructure (SHMII-10), Porto, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1u1jeuJ81nB2oxeFz7h0dhqql5n_1IfoO/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Analysis of arch dams under high-intensity seismic actions. Joint movements and concrete failure</h3>
                            <p className='pub-afil'>Alegre, A.; Oliveira, S.; Proença, J., Mendes, P. (2021)</p>
                            <p className='pub-afil'>Congresso Nacional Reabilitar & Betão Estrutural 2020, LNEC, Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/11M0spm36Ab03hx25UqVFbIFUBuxvsLAK/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Dynamic behavior of Cahora Bassa dam under ambiente excitation and under seismic actions</h3>
                            <p className='pub-afil'>Alegre, A.; Oliveira, S.; Carvalho, E.; Mendes, P.; Proença, J. (2021)</p>
                            <p className='pub-afil'>Congresso Nacional Reabilitar & Betão Estrutural 2020, LNEC, Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/11M0spm36Ab03hx25UqVFbIFUBuxvsLAK/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Monitoring and modeling the dynamic behavior of Cabril dam in the period 2008-2020</h3>
                            <p className='pub-afil'>Oliveira, S.; Alegre, A.; Ferreira, I.; Mendes, P.; Proença, J. (2021)</p>
                            <p className='pub-afil'>Congresso Nacional Reabilitar & Betão Estrutural 2020, LNEC, Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1rpmpn3h6wOeD0GE_ghJDNUXU9124vLhr/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic and Structural Health Monitoring of Cahora Bassa Dam</h3>
                            <p className='pub-afil'>Oliveira, S.; Carvalho, E.; Matsinhe, B.; Mendes, P.; Alegre, A.; Proença, J. (2021)</p>
                            <p className='pub-afil'>In: Rizzo, P., Milazzo, A. (eds) European Workshop on Structural Health Monitoring. EWSHM 2020. Lecture Notes in Civil Engineering, vol 127. Springer, Cham</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1R-5XBNf1pjyfDPVuf75EoQEcEwT-RCdf/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Continuous dynamic monitoring of large arch dams and vibration-based damage detection</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Carvalho, E., Mendes, P., Proença, J., Matsinhe, B. (2022)</p>
                            <p className='pub-afil'>HYDRO 2022 – Roles of Hydro in the Global Recovery, Strasbourg, France</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/18hOh5iZLvj1yBxJ_ZBipHlTmDt6LJIb-/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>A study on the influence of the horizontal cracking on the modal parameters of Cabril dam. Experimental and numerical results</h3>
                            <p className='pub-afil'>Oliveira, S., Alegre, A. (2022)</p>
                            <p className='pub-afil'>8th World Conference on Structural Control and Monitoring, Orlando, Florida, USA</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1g3rLkFKFqBOmE_ubui3CuI6ilSm1m6tH/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic response of Cahora Bassa dam. Observation and numerical modeling results</h3>
                            <p className='pub-afil'>Carvalho, E., Oliveira, S., Mendes, P., Proença, J., Alegre, A., Matsinhe, B. (2022)</p>
                            <p className='pub-afil'>9º Congresso Luso-Moçambicano de Engenharia CLME2022, Maputo, Moçambique</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1L8rrALMLulw0jK16TTpalgbDOfdW216i/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Dynamic monitoring of Cahora Bassa dam</h3>
                            <p className='pub-afil'>Carvalho, E., Matsinhe, B., Mendes, P., Oliveira, S., Proença, J., Alegre, A. (2022)</p>
                            <p className='pub-afil'>9º Congresso Luso-Moçambicano de Engenharia CLME2022, Maputo, Moçambique</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1IkNRFgoxOgDdK54_7ujGk5Gdl8k8480F/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Numerical models for seismic analysis of arch dams</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Mendes, P., Proença, J., Carvalho, E., Matsinhe, B. (2022)</p>
                            <p className='pub-afil'>Congreso de Métodos Numéricos en Ingenieria (CMNI2022), Las Palmas de Gran Canaria, Spain</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1tT-sUvhhvJ8ne_W_051Nh6XnRnj27BhX/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Numerical study on the modification of the modal parameters of arch dams due to damages caused by high-intensity earthquakes</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Mendes, P., Proença, J. (2022)</p>
                            <p className='pub-afil'>6as Jornadas Portuguesas de Engenharia de Estruturas, LNEC, Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1wiPBxnfPElJrs5tTTkLFY-e2a-RJ8487/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Analysis of the influence of the horizontal cracking on the modal parameters of Cabril dam</h3>
                            <p className='pub-afil'>Oliveira, S., Alegre, A., Mendes, P., Proença, J. (2022)</p>
                            <p className='pub-afil'>6as Jornadas Portuguesas de Engenharia de Estruturas, LNEC, Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1xwhzVI9k8Xh9x-1Yg-m4wJ8qg86c2i2P/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Cahora Bassa vibrations monitoring between 2010-2022. Analysis of frequencies using HST statistical models for effects separation</h3>
                            <p className='pub-afil'>Oliveira, S., Mendes, P., Rodrigues, M., Alegre, A., Proença, J., Carvalho, E., Matsinhe, B. (2023)</p>
                            <p className='pub-afil'>XII International Conference on Structural Dynamics EURODYN 2023, TU Delft, Delft, Netherlands</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1fOmmietfMl1zUdzgDIEv9xU4tXNROUMa/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>

                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>SSHM Systems for Dams: 12 Years’ Experience in Cahora Bassa Dam. Equipment, Software, and Main Results</h3>
                            <p className='pub-afil'>Carvalho, E., Matsinhe, B., Mendes, P., Oliveira, S., Alegre, A., Ciudad-Real, M., Skolnik, D., El-Idrissi, M. (2023)</p>
                            <p className='pub-afil'>10th International Conference on Experimental Vibration Analysis for Civil Engineering Structures (EVACES 2023). Politecnico Milano, Milan, Italy</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1Hrgxzb0IIKSB74qgSbBqJjPGqsmH6BVK/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Vibration analysis for model calibration and structural condition assessment of Cahora Bassa dam considering the concrete swelling effects</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Mendes, P., Carvalho, E., Matsinhe, B., Proença, J. (2023)</p>
                            <p className='pub-afil'>10th International Conference on Experimental Vibration Analysis for Civil Engineering Structures (EVACES 2023). Politecnico Milano, Milan, Italy</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1EcgUTnuld5qY6nNWwazaWJ_NONJRe2Si/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Software development for automatic structural health monitoring of Cabril dam</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Mendes, P., Proença, J. (2023)</p>
                            <p className='pub-afil'>10th International Conference on Experimental Vibration Analysis for Civil Engineering Structures (EVACES 2023). Politecnico Milano, Milan, Italy</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1Nu3D88VHIe_p81KopIwPiEIN-NxGDQL5/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Dynamic behavior of Cabril dam. Finite element model calibration, structural health monitoring (2008-2023) and seismic safety assessment</h3>
                            <p className='pub-afil'>Oliveira, S., Alegre, A., Ramos, R., Mendes, P., Proença, J. (2023)</p>
                            <p className='pub-afil'>14th International Workshop on Structural Health Monitoring (IWSHM), Stanford University, California, United States</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1QFrc83UJo45yQ0YiXpYEfGnxH80Al6tN/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Analysis of Dam Natural Frequencies Using a Convolutional Neural Network</h3>
                            <p className='pub-afil'>Cabaço, G., Oliveira, S., Alegre, A., Marcelino, J., Manso, J., Marques, N. (2023)</p>
                            <p className='pub-afil'>EPIA Conference on Artificial Intelligence, Faial Island, Azores</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/16uZ0nwQlcHWrS0c9y0l5D6Xlnu5PagpN/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Immersive Situated Analysis of Dams’ Behavior</h3>
                            <p className='pub-afil'>Trindade, N.; Leitão, P.; Gonçalves, D.; Oliveira, S.; Ferreira, A. (2023)</p>
                            <p className='pub-afil'>International Conference on Graphics and Interaction (ICGI2023), Polytechnic University of Tomar</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1IJMDWyeVaUZ7nClH14IT35cyOy1q4FzI/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                </Row>

                {/* Papers In National Journals Section */}
                <h3 className='team-title'>Papers In National Journals</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Dynamic water-structure interaction models in the seismic analysis of arch dams considering linear-elastic behavior. Application to Luzzone dam</h3>
                            <p className='pub-afil'>Oliveira, S., Alegre, A., Espada, M., Câmara, R. (2016)</p>
                            <p className='pub-afil'>Portuguese Journal of Structural Engineering (RPEE), Series III, vol. 2, p. 103-115</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1IKjybosWeHi9FPDLth051hdRKrUQA9cY/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Hydrodynamic pressures on arch dams: numerical and experimental results</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Espada, M., Câmara, R., Lemos, J.V. (2017)</p>
                            <p className='pub-afil'>J. of the Portuguese Assoc. of Experimental Stress Analysis, vol. 28, p. 55-62.</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1bMYVCNC3ZOl8VxjznfD01uoexI8j2-_Y/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic analysis of an ultra-high arch dam using the 3DFE program DamDySSA3.0. Study on the influence of the reservoir water level</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Espada, M., Câmara, R. (2019)</p>
                            <p className='pub-afil'>Portuguese Journal of Structural Engineering (RPEE). Series III, vol. 11, p. 115-125</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/10Gn_FNLeGvSpel-4H733I7gW-AfTvzki/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                </Row>



                {/* Papers In International Scientific Journals Section */}
                <h3 className='team-title'>Papers In International Scientific Journals</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card">
                        {/* <Col>
                            <img src={logos} className="member-photo" />
                        </Col> */}
                        <Col>
                            <h3 className='pub-name'>Seismic and Structural Health Monitoring of Cabril dam. Software development for informed management</h3>
                            <p className='pub-afil'>Oliveira, S; Alegre, A (2020)</p>
                            <p className='pub-afil'>Special Issue of the Journal of Civil Structural Health Monitoring: SHM for informed Management of Civil Structures and Infrastructures, Springer, p. 913-925.</p>

                        </Col>
                    </Col>

                    <Col md='5' className="publication-card">
                        <Col>
                            <h3 className='pub-name'>Seismic and Structural Health Monitoring Systems For Large Dams: Theoretical, Computational and Practical Innovations</h3>
                            <p className='pub-afil'>Oliveira, S.; Alegre, A.; Carvalho, E.; Mendes, P.; Proença, J. (2022)</p>
                            <p className='pub-afil'>Bulletin of Earthquake Engineering. Vol. 20, p. 4483-4512</p>
                            <a class="go-corner" href="https://doi.org/10.1007/s10518-022-01392-1" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>

                    <Col md='5' className="publication-card">
                        <Col>
                            <h3 className='pub-name'>Seismic Safety Assessment of Arch Dams Using an ETA-Based Method with Control of Tensile and Compressive Damage</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Mendes, P., Proença, J., Ramos, R., Carvalho, E. (2022)</p>
                            <p className='pub-afil'>Water. 14, 3835</p>
                            <a class="go-corner" href="https://www.mdpi.com/2073-4441/14/23/3835" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>

                    <Col md='5' className="publication-card">
                        <Col>
                            <h3 className='pub-name'>Extended Reality in AEC</h3>
                            <p className='pub-afil'>Trindade, N.; Ferreira, A.; Pereira, J.M.; Oliveira, S. (2023)</p>
                            <p className='pub-afil'>Int. Journal on Automation in Construction, 154 (2023) 105018</p>
                            <a class="go-corner" href="https://doi.org/10.1016/j.autcon.2023.105018" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                </Row>



                {/* Book Chapters Section */}
                <h3 className='team-title'>Book Chapters</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Seismic and Structural Health Monitoring of Dams in Portugal</h3>
                            <p className='pub-afil'>Oliveira, S., Alegre, A. (2019)</p>
                            <p className='pub-afil'>Limongelli M, Çelebi M (eds) Seismic Structural Health Monitoring - From Theory to Successful Applications. Springer Tracts in Civil Engineering, Springer. Chapter 4, p. 87-113</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1C1j7IlZhCRb4LtvdHkSptIMKI4CBK01q/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>SHM of Cabril dam: arch dam with cracks near the top, due to the unusual crest geometry</h3>
                            <p className='pub-afil'>Oliveira, S.; Ferreira, I., Alegre, A. (2022)</p>
                            <p className='pub-afil'>Chapter 6 fib Bulletin on “Existing Concrete Structures: Life Management, Testing and Structural Health Monitoring”. Fib-International Publications</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/198bbA38SzKFOecqpwBp0eq7KXG39yt7G/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>SHM of Cahora Bassa dam: 170 m high arch dam undergoing a swelling process due to ASR</h3>
                            <p className='pub-afil'>Oliveira, S.; Carvalho, E.; Mendes, P.; Alegre, A. (2022)</p>
                            <p className='pub-afil'>Chapter 6 fib Bulletin on “Existing Concrete Structures: Life Management, Testing and Structural Health Monitoring”. Fib-International Publications</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1aXKT8XMYTEYbVirpEH1q6LAEW2a9sfc9/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                </Row>



                {/* Papers In Journals (Others)*/}
                <h3 className='team-title'>Papers In Journals (Others)</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Monitoring vibrations in large dams</h3>
                            <p className='pub-afil'>Alegre, A.; Oliveira, S.; Carvalho, E.; Matsinhe, B.; Mendes, P.; Proença, J. (2020)</p>
                            <p className='pub-afil'>The International Journal on Hydropower and Dams. Vol. 27, Issue Two, 2020, p. 42-48</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1LsGc7QS32VwMRoG3Ic2LC3GXK8gNhpjX/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Continuous dynamic monitoring of large arch dams and vibration-based damage detection</h3>
                            <p className='pub-afil'>Alegre, A., Oliveira, S., Carvalho, E., Mendes, P., Proença, J., Matsinhe, B. (2022)</p>
                            <p className='pub-afil'>The International Journal on Hydropower and Dams. Vol. 29, Issue 2. 2022, p. 96-105</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1Y_ZZK1kwcrc3DfqEBHFB0_EBKzMpPWOI/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                </Row>



                {/* Master's Theses*/}
                <h3 className='team-title'>Master's Theses</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Development of models for dynamic analysis of structures. Application to concrete dams and auxiliary structures</h3>
                            <p className='pub-afil'> Espada, M (2010)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1wa7r8hWiXsDkfI_b7LVhr5JCT8Z5xGNI/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modeling the dynamic behavior of dam-reservoir-foundation systems. State-space formulation with generalized damping</h3>
                            <p className='pub-afil'> Silvestre, A. (2012)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/12SXBavE3SICPfoXqwfXJqAoIDRbDCamv/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modeling and monitoring the dynamic behavior of arch dams. Automatic modal identification</h3>
                            <p className='pub-afil'> Salvado, P. (2014)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1UyTsJvyoMCYRyez7_ubYMFBYgAEF_TYQ/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modal identification and seismic response simulation of arch dams</h3>
                            <p className='pub-afil'> Osório, A. (2015)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1UfUnjvfXJoF815kR0yB811KdXPVKvR7v/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Analysis of the seismic behavior of Luzzone dam. Development of a 3DFE program using a formulation in displacements and pressures</h3>
                            <p className='pub-afil'> Alegre, A. (2015)</p>
                            <p className='pub-afil'> Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/159snUNTyjEB4L2zQ3V3fu8ObmizJSi3j/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modeling the dynamic behavior of dam-reservoir-foundation systems. Seismic analysis of a multiple arch dam</h3>
                            <p className='pub-afil'> Catarino, A. (2016)</p>
                            <p className='pub-afil'> Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1Jd4_8Pn_P0b9wKPcWBIs2FIDyu-0h6q5/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modeling the seismic behavior of arch dams: study on the influence of the water level</h3>
                            <p className='pub-afil'> Ramos, R. (2017)</p>
                            <p className='pub-afil'> Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1W4UfrfNlHsfgk69qEvkToXJzjZ3qJBSP/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Monitoring vibrations in structures. Time domain modal identification methods</h3>
                            <p className='pub-afil'> Freitas, M. (2017)</p>
                            <p className='pub-afil'> Master's Thesis, Instituto Superior de Engenharia de Lisboa (ISEL), Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1va38gSCJ_6rXx4w_Kj8xQyNrsfskQKy-/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Analysis of Structures in Virtual Reality. Application to Cabril dam</h3>
                            <p className='pub-afil'> Leitão, P. (2022)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior Técnico - Universidade de Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1Uo6ZPvt1yyztuIulWyDSpQATvFjtqocr/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Vibration analysis of dams using a Convolutional Neural Network</h3>
                            <p className='pub-afil'> Cabaço, G. (2022)</p>
                            <p className='pub-afil'>Master's Thesis, FCT - NOVA University Lisbon</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1gUc_2gIAe3goCvVYDoZiCEk-k7OIW4Zo/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>CabrilDamVR: Cabril Dam Photorealistic & Immersive Virtual Reality Experience</h3>
                            <p className='pub-afil'> Chin, R. (2023)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior Técnico - Universidade de Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1PfI09OXQNzzf8sOqTrW2SbbqzEjhG-QM/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Immersive Analytics for Dam Analysis</h3>
                            <p className='pub-afil'> Sequeira, T. (2023)</p>
                            <p className='pub-afil'>Master's Thesis, Instituto Superior Técnico - Universidade de Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1sOwsqWmRfKLrQfw7xjwnB4Kr2G5Ak2AF/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                </Row>



                {/* PhD Theses*/}
                <h3 className='team-title'>PhD Theses</h3>
                <Row className="publication-cards" style={{ justifyContent: "center" }}>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modelos para Análise do Comportamento de Barragens de Betão considerando a Fissuração e os Efeitos do Tempo. Formulação de Dano</h3>
                            <p className='pub-afil'> Oliveira, S. (2000)</p>
                            <p className='pub-afil'>PhD Thesis, University of Porto</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1_-CnT4VR310YjKRL6rdR4dIIejDh2dBn/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Observation and analysis of the dynamic behavior of concrete dams</h3>
                            <p className='pub-afil'> Mendes, P. (2010)</p>
                            <p className='pub-afil'>PhD Thesis, University of Porto</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1cPM1Z37oeWrTbR-MnuyQIzgvZdDBDD9C/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Modelling and monitoring the dynamic behaviour of concrete dams. Modal analysis and seismic response</h3>
                            <p className='pub-afil'> Alegre, A. (2021)</p>
                            <p className='pub-afil'>PhD Thesis, Instituto Superior Técnico - Universidade de Lisboa, Portugal</p>
                            <a class="go-corner" href="https://drive.google.com/file/d/1o4WLuW4AhGACfQNa7ITpVqUjs4x6d_Nf/view?usp=sharing" target="_blank">
                                <div class="go-arrow">
                                    →
                                </div>
                            </a>
                        </Col>
                    </Col>
                    <Col md='5' className="publication-card-no-ball">
                        <Col>
                            <h3 className='pub-name'>Development of Hybrid HST-FE Models For Effects Separation and Deterioration Assessment of Concrete Dams</h3>
                            <p className='pub-afil'> Rodrigues, M. (2024)</p>
                            <p className='pub-afil'>Instituto Superior Técnico - Universidade de Lisboa, Portugal</p>
                        </Col>
                    </Col>
                </Row>

            </Container>
        </div >
    )
}
export default Publications;